import React, { useEffect } from "react"
import Slider from "react-slick";
import _ from "underscore";
import ProductVariation from "./ProductVariation";
import Button from "react-bootstrap/Button";
import {Container} from "react-bootstrap";
import Image from "react-bootstrap/Image";
import config from "../../../config";
import {carouselSettings, getCookie} from "../../common/utils";
import { useDispatch, useSelector } from "react-redux"
import { getSimilarFromBE } from "../../actionCreators/boostCommerceAC"

const ProductsCarousel = ({title, alt_prefix, products, products_total, see_all_url, custom_class, eventType}) => {
    const slider_settings = {
        className: "products-carousel__cards",
        dotsClass: "slick-dots--custom",
    }
    const sliderSettings = carouselSettings(slider_settings);
    const is_b2b = getCookie('is_b2b');
    const is_wholesale_active = getCookie("is_wholesale_active");
    const dispatch = useDispatch();
    const product = useSelector((state) => state.shopifyReducer.product);

    useEffect(() => {
      if (see_all_url && product && eventType) {
        const formatUrl = see_all_url.replace(`${config.host_rebag_shop}/collections/new-arrivals?_=pf&build_filter_tree=true&`, "");
        dispatch(getSimilarFromBE(formatUrl, product.id, eventType));
      }
      if (see_all_url === null && eventType) {
          dispatch({type: `${eventType}_LOADED`});
      }
    }, [see_all_url, product])

    if (!products.length) return null;

    return (
        <div className={`products-carousel ${custom_class ? custom_class : ""}`}>
            <h3 className="products-carousel__title">{title}</h3>
            <div className="products-carousel__cards-container">
                <Container>
                    <Slider {...sliderSettings}>
                        {_.map(products, (product) => {
                            return (
                                <ProductVariation
                                    key={product.id}
                                    product_variation={product}
                                    alt_prefix={alt_prefix}
                                    is_b2b={is_b2b}
                                    is_wholesale_active={is_wholesale_active}
                                />
                            );
                        })}
                        {products_total > 14 && see_all_url &&
                        <div className="products-carousel__card products-carousel__card--more-items">
                            <a
                                href={see_all_url}
                                className="products-carousel__card-link-container"
                            >
                                <Image alt="More Matches Available"
                                       className="saved-search__more-items-icon"
                                       src={`${config.MEDIA_URL}/img/shopping-bag-thin.svg`}
                                />
                                <div className="saved-search__more-items-title">
                                    More Matches Available
                                </div>
                                <div className="saved-search__more-items-link">
                                    View All
                                </div>
                            </a>
                        </div>
                        }
                    </Slider>
                </Container>
            </div>
            {see_all_url &&
            <Button
                className="products-carousel__see-all-cta rbg-btn-ghost"
                href={see_all_url}
                variant="secondary"
            >
                See All
            </Button>
            }
        </div>
    )
}

export default ProductsCarousel;